<template>
  <div class="error">
    <div class="error_txt">
      <h1 class="error-title icons"><i class="fas fa-bomb"></i> <i class="fas fa-bug"></i> <i class="fas fa-exclamation-triangle"></i></h1>
      <h1 class="error-title">No to się narobiło...</h1>
      <p v-if="error.file">W pliku: <b>{{error.file}}</b> : <b>{{error.line}}</b> mamy błąd:</p>
      <p class="error-error" v-html="error.message"></p>
      <h2 v-if="error.dump"><i class="fas fa-code"></i>&nbsp;Zrzut danych:</h2>
      <pre v-if="error.dump">{{ error.dump }}</pre>
      <h3 v-if="error.stacktrace">Stack trace:</h3>
      <div class="stacktrace" v-html="error.stacktrace">
      </div>
    </div>
  </div>
</template>


<style lang="scss">
.error {
  width: 100vw;
  min-height: 100vh;
}

.error_txt {
  padding: 10vh 13vw 0 13vw;
  word-wrap: break-word;
  path {
    fill: $error-color;
  }
  .error-error {
    color: $error-color;
    font-size: 120%
  }
  .stacktrace {
    font-size: 70%
  }
  pre {
    font-size: 15px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgb($quinary-color);
    overflow: initial;
  }

}
h1.error-title {
  color: $error-color;
}
h1.icons {
  font-size: 4rem;
}
</style>

<script>
export default {
  name: "fcwpError",
  props: ["metaError", "itemError"],
  computed: {
    error: function() {
      if (this.metaError !== undefined) {
        return this.metaError;
      }
      return this.itemError;
    }
  }
}
</script>